module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/229-turkmenistan-f526d16691d6f1432c003f8be724b46f.svg";